import * as E from 'fp-ts/Either';
import { useEffect, useState } from 'react';
import { User, single } from '../api/users';

export const useUser = (token?: string | null, id?: string) => {
  const [user, setUser] = useState<User | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token || !id) {
      return;
    }
    single(token, id).then((result) =>
      E.isLeft(result) ? setError(result.left.message) : setUser(result.right)
    );
  }, [token, id]);

  return { user, error };
};
